
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pos-software-partners/gsp",
      function () {
        return require("private-next-pages/pos-software-partners/gsp.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pos-software-partners/gsp"])
      });
    }
  